<template>
  <page-header-wrapper>
    <a-card :bordered="false">
           <span slot="title" class="card-title">
        <a-button size="small" @click="$router.go(-1)" style="margin-right: 15px;">
          <a-icon type="left" />返回
        </a-button>
        <span>生成SKU</span>
      </span>
      <a-form-model ref="form" :model="form" :rules="rules">
<!--        <a-form-model-item label="商品名称" prop="goodsId" >-->
<!--          <a-select style="width: 200px" v-model="form.goodsId"  placeholder="请选择商品">-->
<!--            <a-select-option  v-for="item in goodsList" :value="item.id">{{item.goodsName}}</a-select-option>-->
<!--          </a-select>-->
<!--        </a-form-model-item>-->

        <div>
          <a-form-model-item label="请选择属性">
            <a-select v-model="curSpec" show-search placeholder="请选择属性" style="width: 200px"
                      @change="handleChangeSpec">
              <a-select-option :value="item.id" v-for="(item, index) in specList" :key="index">
                {{ item.specName }}
              </a-select-option>
            </a-select>
            <a-button style="margin-left: 8px" v-if="curSpec" type="primary" @click="confirmSpecBtn">确定
            </a-button>
          </a-form-model-item>

          <!-- start展示选择的属性信息 -->
          <div v-if="specValueList.length">
            <div class="box margin-bottom-sm" v-for="(item, index) in specValueList" :key="index">
              <div class="margin-bottom-sm">{{ item.specName }}
                <!--                    <a-icon type="close-circle" class="cursorhand margin-left-sm" @click="delSpec(index)"/>-->
                <a-popconfirm title="确定要删除此属性吗?" ok-text="确定" cancel-text="取消" @confirm="delSpec(index)">
                  <a-icon type="close-circle" class="delSpec"/>
                </a-popconfirm>
              </div>


              <div class="flex align-center">
                <div v-for="(item1, index1) in item.specValueList" :key="index1" class="flex align-center">
                  <a-input v-model="item1.specValueName" placeholder="请输入" @blur="changeGuigeshuju($event,item1,index, index1)"  size="small" style="width: 80%"/>
                  <a-icon type="close-circle" class="cursorhand margin-left-sm"
                          @click="del(2, index, index1)"></a-icon>

                </div>
                <a-button v-if="item.specValueList.length < 5 && item.showBtn"
                          type="primary" size="small"
                          @click="add(2, index)" class="margin-left-sm margin-right">
                  添加
                </a-button>
              </div>
            </div>
          </div>
        </div>

      <!-- 操作 -->
      <div class="table-operations">
        <a-button type="primary" @click="addSpec">
          <a-icon type="plus" />立即生成
        </a-button>
      </div>
      <!-- 数据展示 -->
      <a-table
        :loading="loading"
        :size="tableSize"
        rowKey="id" :scroll="{x: 1500,y:'calc(100vh - 300px)'}"
        :columns="columns"
        :data-source="form.skuList"
        :pagination="false"
        :bordered="tableBordered"
      >
        <span slot="stock" slot-scope="text, record">
          <a-input-number style="width: 200px" :min="0" v-model="record.stock" placeholder="请输入库存"/>
        </span>
        <span slot="price" slot-scope="text, record">
          <a-input-number style="width: 200px" :min="0" v-model="record.price" placeholder="请输入价格"/>
        </span>
<!--        <span slot="requireScores" slot-scope="text, record">-->
<!--          <a-input-number :min="0" v-model="record.requireScores" placeholder="请输入所需积分数"/>-->
<!--        </span>-->
<!--        <span slot="cashCoupon" slot-scope="text, record">-->
<!--          <a-input-number style="width: 200px" :min="0" v-model="record.cashCoupon" placeholder="请输入所需现金券数"/>-->
<!--        </span>-->

        <div slot="image"  slot-scope="text, record" style="margin-left:70px">
          <a-upload
            listType="picture-card"
            class="table-uploader"
            :showUploadList="false"
            :customRequest='fileUploadRequest'
            :beforeUpload="beforeUpload"
            @change="handleChangeTable($event,record)"
          >
            <img v-if="record.image" :src="record.image" alt="规格图片"
                 style="width: 48px;height: 48px;"/>
            <div v-else>
              <a-icon :type="record.uploadLoading ? 'loading' : 'plus'"/>
              <div class="ant-upload-text">上传</div>
            </div>
          </a-upload>
        </div>

        <span slot="operation" slot-scope="text, record">
          <a @click="handleDelete(record)" v-hasPermi="['goods:sku:remove']">
            <a-icon type="delete" />删除
          </a>
        </span>
      </a-table>

        <div class="bottom-control">
          <a-space>
            <a-button v-if="form.skuList.length>0" type="primary"  @click="submitForm">
              保存
            </a-button>
            <a-button type="dashed" @click="cancel">
              取消
            </a-button>
          </a-space>
        </div>
      </a-form-model>
    </a-card>
  </page-header-wrapper>
</template>

<script>
import { tableMixin } from '@/store/table-mixin'
import {listGoodsInfo} from "@/api/goods/goodsInfo";
import {listSpec} from "@/api/goods/spec";
import {addSpecValue,delSpecValue,updateSpecValue} from "@/api/goods/specValue";
import UploadFileToOSS from "@/utils/upload-file-to-oss"
import {batchAdd} from "@/api/goods/sku";

export default {
  name: 'AddSku',
  components: {

  },
  mixins: [tableMixin],
  data () {
    return {
      form:{
        goodsId:null,
        skuList:[],
      },
      curSpec:null,
      loading: false,
      specValueList:[],
      goodsList: [],
      specList:[],
      rules: {
        goodsId: [
          {required: true, message: '商品ID不能为空', trigger: 'change'}
        ],
      },
      columns: [
        {
          title: 'SKU名称',
          dataIndex: 'skuName',
          ellipsis: true,
          align: 'center'
        },
        {
          title: 'SKU名称英文',
          dataIndex: 'skuNameEn',
          ellipsis: true,
          align: 'center'
        },
        {
          title: '图片',
          dataIndex: 'image',
          ellipsis: true,
          align: 'center',
          scopedSlots: {customRender: 'image'}
        },
        {
          title: '价格',
          dataIndex: 'price',
          ellipsis: true,
          scopedSlots: {customRender: 'price'},
          align: 'center'
        },
        // {
        //   title: '需积分数',
        //   dataIndex: 'requireScores',
        //   scopedSlots: {customRender: 'requireScores'},
        //   ellipsis: true,
        //   align: 'center'
        // },
        // {
        //   title: '需现金券数',
        //   dataIndex: 'cashCoupon',
        //   scopedSlots: {customRender: 'cashCoupon'},
        //   ellipsis: true,
        //   align: 'center'
        // },
        {
          title: '库存',
          dataIndex: 'stock',
          scopedSlots: {customRender: 'stock'},
          ellipsis: true,
          align: 'center'
        },
        {
          title: '操作',
          dataIndex: 'operation',
          width: '18%',
          scopedSlots: { customRender: 'operation' },
          align: 'center'
        }
      ],
    }
  },
  filters: {
  },
  created () {
    this.form.goodsId = this.$route.query.goodsId
    // 闲橙健康进来不显示需现金券数列  
     console.log(this.$route.query.showCashCoupon, "showCashCoupon");
    console.log(this.columns, "原始columns");
    if (this.$route.query.showCashCoupon) {
        this.columns = this.columns.filter(col =>
        col.dataIndex !== 'cashCoupon' 
        )
    }
    console.log(this.columns, "修改后columns");
    this.initGoods()
    this.initSpec()
  },
  computed: {
  },
  watch: {
  },
  methods: {
    cancel(){
      this.reset()
    },
    reset(){
      this.form={
        goodsId:null,
        skuList: []
      }
      this.curSpec = null
      this.specValueList = []
      this.initSpec()
    },
    initSpec(){
      listSpec({isDeleted:0}).then(res=>{
        this.specList = res.data
      })
    },
    handleChangeSpec(e) {
      console.log('选中属性', e)
      if(!this.form.goodsId){
        this.$message.error('请选择商品')
        return
      }
      this.curSpec = e
    },
    /**
     * 确定属性添加按钮
     */
    confirmSpecBtn() {
      /**
       *   1:往商品属性值specValueList 添加属性数据
       *   2：移除属性列表选择的那一项specList 删除curSpec
       *   3：curSpec选择的属性清空
       */
      if (this.curSpec) {
        if( this.specValueList.length +1 > 2){
          this.$message.error("商品属性不能超过3级")
          return
        }
        let filterIndex = this.specList.findIndex(i => i.id == this.curSpec);
        if (filterIndex !== -1) {
          let addSpecValueItem = {
            id: this.specList[filterIndex].id,
            remark: this.specList[filterIndex].remark,
            specName: this.specList[filterIndex].specName,
            specDes: this.specList[filterIndex].specDes,
            showBtn:true,
            specValueList: [{
              specId: this.specList[filterIndex].id,
              specName: this.specList[filterIndex].specName,
              specValueName: '',
              isVisible: 1,
              sort: 0,
              remark: '',
              id: ''
            }]
          }
          this.specValueList.push(addSpecValueItem);
          // setTimeout(() => {
          this.specList.splice(filterIndex, 1);
          // },700)
          this.curSpec = null;
        }
      }

    },
    /**
     * 删除属性
     */
    delSpec(index) {
      let mapIdArray = this.specValueList[index].specValueList.map(i => i.id);
      if (mapIdArray.length) {
        let filterIds = mapIdArray.filter(i => i != '');
        if (filterIds.length) {
          delSpecValue(filterIds).then(res => {
            if (res.code == 20001) {
              let oneItem = this.specValueList[index];
              oneItem.specValueList = []
              this.specList.push(oneItem)
              this.specValueList.splice(index, 1)
            }
          })
        } else {
          let oneItem = this.specValueList[index];
          oneItem.specValueList = []
          this.specList.push(oneItem)
          this.specValueList.splice(index, 1)
        }
      } else {
        let oneItem = this.specValueList[index];
        oneItem.specValueList = []
        this.specList.push(oneItem)
        this.specValueList.splice(index, 1)
      }
    },
    del(num, index, index1) {
      this.specValueList[index].specValueList.splice(index1, 1)
    },
    changeGuigeshuju(e,item,index,index1) {
      console.log('改变了', item)
      if(item.id) {
        updateSpecValue(item).then(res => {
          if(res.code == 20001) {

          } else {
            this.$message.info('修改失败,请重试');
          }
        })
      } else {
        item.goodsId = this.form.goodsId
        addSpecValue(item).then(res => {
          if (res.code == 20001) {
            this.$set(item,'id',res.data.id)
            console.log('改变后' , item)
          } else {
            this.$message.info('增加失败,请重试');
          }
        })
      }
    },
    add(num, index, index1) {
      if (num == 2) {
        if (this.specValueList[index].specValueList[this.specValueList[index].specValueList.length - 1].specValueName) {
          this.specValueList[index].specValueList.push({
            specId: this.specValueList[index].id,
            specName: this.specValueList[index].specName,
            specValueName: '',
            isVisible: 1,
            sort: 0,
            remark: '',
            id: ''
          })


        } else {
          this.$message.warning("请填写上一个属性值")
        }
      }
    },

    submitForm(){
      this.$refs.form.validate(valid => {
        if (valid) {
          batchAdd(this.form).then(res=>{
            this.$message.success("操作成功")
            this.reset()
          })
        }
      })
    },

    addSpecNew(){
      let arr = this.specValueList;
      let results = [];
      let result = [];
      console.log('原始数据',arr)
      doExchange(arr, 0);

      doExchange(arr, 0);
      function doExchange(arr, index) {
        for (var i = 0; i < arr[index][0].specValueList.length; i++) {
          result[index] = arr[index][0].specValueList[i];
          if (index != arr.length - 1) {
            doExchange(arr, index + 1)
          } else {
            let everyItem = {
              skuName:result.map(i =>i.specValueName).join('/'),
              specSpecValueList:result.map(i => i.id).join(','),
              // attrValueItemsFormat:result.map(i =>i.specId + ':' +  i.id).join('/')
              goodsId: null,
              stock: null,
              price: null,
              originalPrice:null,
              uploadLoading: false,
              image: null,
            }
            results.push(everyItem)
          }
        }

      }

    },
    addSpec(){
      let arrs = this.specValueList;
      console.log(arrs, "arrs");
      let result =[]
      if(arrs.length === 1) {
        arrs[0].specValueList.forEach(j => {
          if(j.id) {
            result.push({
              skuName: `${j.specValueName}`,
              specSpecValueList:[{specId:j.specId,specValueId:j.id}],
              goodsId: null,
              stock: null,
              price: null,
              originalPrice:null,
              uploadLoading: false,
              image: null,
            })
            // saveArr
          }
        })
      } else {
      result = arrs.reduce((acc, cur, index) => {
        console.log('acc')
        console.log(acc)
        console.log(cur)
        // 从第二项开始合并值
        if (index > 0) {
          let saveArr = []
          acc.specValueList.forEach(item => {
            cur.specValueList.forEach(subItem => {
              console.log('进来了2222')
              if(subItem.id && item.id) {
                saveArr.push({
                  skuName: `${item.specValueName}/${subItem.specValueName}`,
                  skuNameEn: null,
                  specSpecValueList:[{specId:item.specId,specValueId:item.id},{specId:subItem.specId,specValueId:subItem.id}],
                  goodsId: null,
                  stock: null,
                  price: null,
                  originalPrice:null,
                  uploadLoading: false,
                  image: null,
                })
              }
            })
          })
          acc = saveArr
        }
        return acc
      }, arrs[0]) }// 把数组的第一项传入作为初始值
      console.log('result',result)
      this.form.skuList = result
    },

    handleDelete(val){
      let int= this.form.skuList.indexOf(val)
      this.form.skuList.splice(int,1)
    },
    initGoods() {
      listGoodsInfo().then(res=>{
        this.goodsList = res.data
      })
    },

    beforeUpload: function (file) {
      return new Promise((resolve, reject) => {
        if (file.size > 5 * 1024 * 1000) {
          this.$message.warning("图片大小不能超过5M----")
          return reject(false)
        }

        var fileType = file.type;
        if (fileType.indexOf('image') < 0) {
          this.$message.warning('请上传图片');
          return reject(false);
        }
        resolve(true)
      });
    },
    handleChangeTable(info, record) {

      if (info.file.status === 'uploading') {
        record.uploadLoading = true;
        return
      }
      if (info.file.status === 'done') {
        // let response = info.file.response;
        record.uploadLoading = false;
        record.image = info.file.originFileObj.ossUrl;
      }
    },

    fileUploadRequest(fileInfo) {
      new UploadFileToOSS([fileInfo.file], {
        finally: (res) => {
          // Log.info('multi-img-upload', res);
          const ossUrl = res[0].url;
          fileInfo.file.ossUrl = ossUrl;
          fileInfo.file.ossName = ossUrl;
          fileInfo.onSuccess();
        },
      });
    },

  }
}
</script>
